import React from 'react'
import {Link} from 'react-router-dom'
import CheckIcon from '../../../../media/felsv/CheckIcon.svg'
import {useDispatch} from 'react-redux'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision} from '../../../../actions/action-creators'

const FooterResumen = () => {
  const disptach = useDispatch()
  const {facturacionClicEmitirFactura} = bindActionCreators(actionFacturacionEmision, disptach)

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
      <div className='card'>
        <div className='w-layout-vflex card-content'>
          <div className='w-layout-hflex button-actions'>
            <Link to='/emitir-factura/formulario' className='m button transparent botton-footer'>
              <div>Regresar</div>
            </Link>
            <div style={{width: '70%'}}></div>
            <button className='m button botton-footer' onClick={facturacionClicEmitirFactura}>
              <div>Emitir</div>
              <img src={CheckIcon} loading='lazy' alt='Emitir' />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FooterResumen
